<template>
  <default-app-bar :showCancel="false">
    <template v-slot:menu>
      <v-app-bar-nav-icon
        @click.stop="toogleDrawer"
        color="primary"
      ></v-app-bar-nav-icon>
    </template>
    <template v-slot:title>
      <v-toolbar-title class="px-0">
        <img
          src="/assets/images/brand/primary-icon-logo.svg"
          class="d-lg-none d-block"
          width="35"
        />
        <img
          src="/assets/images/brand/primary-horizontal-logo.svg"
          class="d-none d-lg-block"
          width="180"
        />
      </v-toolbar-title>
      <span
        class="d-none d-md-block ml-1 primary--text text-button"
        v-if="versionApp"
        :title="'Compilación ' + compilacion"
        >V{{ versionApp }}</span
      >
      <v-chip v-if="tipoDeNegocio" small label color="primary" class="d-none d-md-flex ml-3" title="Tipo de negocio">
        <v-icon x-small left>{{ tipoDeNegocio.icono }}</v-icon>{{ tipoDeNegocio.texto }}
      </v-chip>
      <v-chip v-if="$store.getters.turn" small label outlined class="d-none d-lg-flex ml-3 turno-abierto"
        :title="'Turno abierto: ' + $filters.datetime($store.getters.turn.opening_date)">
        <v-icon x-small left>mdi-clock-outline</v-icon>Turno desde {{ turnoCorto() }}
      </v-chip>
    </template>

    <template v-slot:actions>
      <!-- El POS pone aquí sus propios botones; las demás pantallas muestran estos. -->
      <slot name="acciones">
      <div class="d-flex flex-row grey lighten-4 rounded-pill py-1 px-2 me-2">
        <v-btn
          fab
          :x-small="$store.getters.mobile ? true : false"
          :small="!$store.getters.mobile ? true : false"
          class="my-auto"
          @click="openTutorials()"
          :title="$t('tutorials')"
        >
          <v-icon color="grey">mdi-play-circle-outline</v-icon>
        </v-btn>
      </div>
      <div
        class="d-flex flex-row grey lighten-4 rounded-pill pr-1 py-1 me-2"
        account="chat"
      >
        <SupportChat />
      </div>
      <PaymentAnnouncement />
      </slot>
      <BotonCerrarTurno v-if="!$slots.acciones" />


      <!-- <div v-if="!$store.getters.mobile">
        <v-btn icon @click="openHelp" title="Ayuda" class="blue lighten-5"
          ><v-icon color="primary">mdi-help-circle</v-icon>
        </v-btn>
      </div> -->
      <v-menu
        bottom
        left
        offset-y
        origin="top right"
        transition="scale-transition"
        class="account-menu"
      >
        <template v-slot:activator="{ on }">
          <v-btn dark icon v-on="on" class="ml-1" id="btn-menu-profile" title="Mi cuenta" aria-label="Mi cuenta">
            <v-avatar size="35" class="primary">
              <v-icon color="white" size="18">mdi-account</v-icon>
            </v-avatar>
            <v-icon color="grey">mdi-chevron-down</v-icon>
          </v-btn>
        </template>

        <v-list style="width: 350px !important">
          <v-list-item
            v-if="$store.getters.user"
            class="d-flex justify-center align-center"
          >
            <div class="account-header text-center">
              <v-list-item two-line class="pa-0 red mx-auto">
                <div>
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-avatar
                        v-if="
                          $store.getters.company && $store.getters.company.logo
                        "
                      >
                        <img
                          :src="
                            $http.getBaseUrlPublicFiles() +
                            $store.getters.company.logo
                          "
                          :alt="$store.getters.company.name"
                        />
                      </v-list-item-avatar>

                      <v-list-item-content class="text-left">
                        <v-list-item-title
                          v-if="$store.getters.company"
                          class="pb-0 primary--text"
                          >{{ $store.getters.company.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle v-if="$store.getters.user">{{
                          $store.getters.user.name
                        }}</v-list-item-subtitle>

                        <div class="d-flex align-center">
                          <span
                            v-if="
                              $store.getters.user.rol &&
                              $store.getters.user.rol.name
                            "
                            class="me-1"
                            ><v-chip small>{{
                              $store.getters.user.rol.name
                            }}</v-chip></span
                          >
                          <span v-if="versionApp" class="caption grey--text"
                            >v{{ versionApp }} · {{ compilacion }}</span
                          >
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-list-item>
            </div>
          </v-list-item>

          <v-divider></v-divider>

          <!-- Opciones propias de la pantalla (en el POS: pendientes, mesas, sincronizar). -->
          <slot name="items-cuenta"></slot>

          <v-list-item id="menu-item-tour" class="mt-2" @click="$root.$emit('pos-tour:iniciar')">
            <v-list-item-icon class="mr-3"><v-icon>mdi-map-marker-path</v-icon></v-list-item-icon>
            <v-list-item-title>Ver recorrido de esta pantalla</v-list-item-title>
          </v-list-item>

          <v-list-item
            id="menu-item-logout"
            class="text-center grey--text mt-2"
          >
            <v-btn
              @click="$store.dispatch('logoutAuth')"
              elevation="0"
              title="Cerrar sesión"
              block
              outlined
              color="primary"
              class="rounded-lg"
              >{{ $t("logout") }}</v-btn
            >
          </v-list-item>
        </v-list>
      </v-menu>
      <!--a v-if="$store.getters.mobile" @click="dialogFilter = true"><v-icon>mdi-magnify</v-icon></a-->
    </template>
  </default-app-bar>
</template>
<script>
import BotonCerrarTurno from "./BotonCerrarTurno.vue";
import SupportChat from "../../../../layouts/header_components/SupportChat.vue";
export default {
  name: "AppMenu",
  data: () => ({
    app_version: process.env.VUE_APP_BASECONFIG_APP_VERSION,
    title: "AppMenu",
    localVersion: null,
  }),
  components: {
    BotonCerrarTurno,
    SupportChat,
    PaymentAnnouncement: () =>
      import(
        "@/components/modules/pos/components/payment-announcement/PaymentAnnouncement.vue"
      ),
  },
  mounted() {
    this.load();
    this.localVersion = localStorage.getItem("app_version");
  },
  computed: {
    // Cambia con cada compilación (commit y fecha); la versión de .env se sube a mano.
    compilacion() {
      return process.env.VUE_APP_COMPILACION || "";
    },
    versionApp() {
      // Una sola fuente para la versión: la del programa de escritorio o, en la web, la de la compilación. Antes la barra
      // mezclaba la compilación con un valor viejo de localStorage y el menú de usuario esperaba 50 ms a tenerla.
      return process.env.VUE_APP_BASECONFIG_APP_VERSION || "";
    },
    tipoDeNegocio() {
      const g = this.$store.getters;
      if (g.isRestaurant) return { texto: "Restaurante", icono: "mdi-silverware-fork-knife" };
      if (g.isDrugStore) return { texto: "Droguería", icono: "mdi-pill" };
      if (g.company && g.company.type && g.company.type.id == 1) return { texto: "Retail", icono: "mdi-storefront-outline" };
      return null;
    },
  },
  methods: {
    // «2026-09-19 10:10 am»: la hora de apertura del turno sin los segundos, para la barra.
    turnoCorto() {
      const t = this.$store.getters.turn;
      return t ? String(this.$filters.datetime(t.opening_date)).replace(/:\d{2}(?=\s?[ap]m)/i, "") : "";
    },
    openHelp() {
      window.open(process.env.VUE_APP_BASECONFIG_URL_HELP, "_blank");
    },
    launchMenuPos(evt) {
      return false;
    },
    toogleDrawer() {
      this.$store.commit("toggle");
    },
    async load() {
      setTimeout(async () => {
        this.app_version = process.env.VUE_APP_BASECONFIG_APP_VERSION;
        await this.$db.load();
        const installed = await this.$db.itsInstalled();
      }, 50);
    },

    async openTutorials() {
      const res = await this.$http.get(
        "api/v1/get-url-lms-nubempresa",
        null,
        true
      );
      if (res.success) {
        window.open(res.data, "_blank");
      }
    },
  },
};
</script>
